export function getLabelWithEllipsis(label: string, maxLength: number, trimLength: number): string {
  if (label && label.length > maxLength) {
    return `${label.slice(0, trimLength)}...`;
  }

  return label;
}
